// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2vP2G","legacyBtn":"MutateMid_legacyBtn__1LpI_"};